import styled from 'styled-components';

export const HomePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1024px;
  margin: 20px auto;
  text-align: left;
  justify-content: center;
  .lead {
    font-size: 1.05rem;
    font-weight: 500;
  }
`;
